import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { AdminTestContext } from '@orientaction/Context';
import OaAccordion from '../OaAccordion';
import OaPopin from '@orientaction/commons/Popin';
import { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import NoVariable from './NoVariable';
import style from './style';
import { Collapse, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import OaLabel from '@orientaction/commons/OaLabel';
import VariableDrawer from '../VariableDrawer';
import { cloneDeep } from 'lodash';

const VariablesSection = ({ idAglomeration }: any) => {
  const {
    test: {
      test: currentTest,
      variableDeletionConfirmPopin,
      errors,
      toDeleteVariablesAglomerationIds,
      aglomerations
    },
    updateTest,
  } = useContext<any>(AdminTestContext);

  const variables = useMemo(() => {
    return aglomerations[idAglomeration]?.variables;
  }, [aglomerations, idAglomeration]);

  const questions = useMemo(() => {
    return aglomerations[idAglomeration]?.questions;
  }, [aglomerations, idAglomeration]);

  const [toDeleteVariableIndex, setToDeleteVariableIndex] = useState<any>();
  const [isExpanded, setIsExpanded] = useState(true);

  const classes = style();

  const handleClick = () => {
    updateTest({ variableAglomerationDrawerOpen: true, idAglomerationSelected: idAglomeration });
  };


  const handlePopinConfirm = () => {
    const idx = toDeleteVariableIndex;
    const toDeleteVariable = variables[idx];
    const { id: toDeleteVariableId } = toDeleteVariable;
    const cloneAglomerations = cloneDeep([...aglomerations]);

    // Mise à jour des questions en filtrant les réponses liées à la variable supprimée
    const updatedQuestions = questions.map((q:any) => ({
      ...q,
      responses: q?.responses?.map((resp: any) => ({
        ...resp,
        // Supposons que chaque 'variable' dans 'responses' est un tableau d'objets,
        // nous filtrons ce tableau pour exclure la variable supprimée.
        variable: resp?.variable?.filter((varObj: any) => varObj.id !== toDeleteVariableId),
      })),
    }));

    const newVariables = [...variables.slice(0, idx), ...variables.slice(idx + 1)];
    cloneAglomerations[idAglomeration].variables = newVariables;
    cloneAglomerations[idAglomeration].questions = updatedQuestions;

    updateTest({
      aglomerations: cloneAglomerations,
      toDeleteVariablesAglomerationIds: toDeleteVariable?.isNew
        ? toDeleteVariablesAglomerationIds
        : [...toDeleteVariablesAglomerationIds, toDeleteVariableId],
      variableDeletionConfirmPopin: {
        open: false,
        title: '',
        handlePopinConfirm: undefined,
        handlePopinClose: undefined,
        data: undefined,
      },
    });
  };

  const handlePopinClose = () => {
    updateTest({
      variableDeletionConfirmPopin: {
        open: false,
        title: '',
        handlePopinConfirm: undefined,
        handlePopinClose: undefined,
        data: undefined,
      },
    });
  };

  const handleDelete = (index: number) => (e: any) => {
    e.stopPropagation();
    // open confirm popin
    setToDeleteVariableIndex(index);
    updateTest({
      variableDeletionConfirmPopin: {
        open: true,
        title: 'Confirmation de suppression',
        content:
          'Êtes vous sûr de vouloir supprimer cette variable ? Toutes les réponses qui lui sont liées seront également supprimées définitivement.',
        handlePopinConfirm,
        handlePopinClose,
      },
    });
  };

  const handleEdit = (index: number) => (e: any) => {
    e.stopPropagation();
    updateTest({ variableAglomerationDrawerOpen: true, variableAglomerationToEdit: { ...variables[index], index }, idAglomerationSelected: idAglomeration });
  };

  const OaAccordionDetails = (variable: any) => () => {
    return (
      <p
        className={classes.text}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          // eslint-disable-next-line react/destructuring-assignment
          __html: variable.description,
        }}
      />
    );
  };
  const isVariableButtonDisabled = currentTest?.diagram?.id === 1 && variables?.length === 2;

  return (
    <div style={{ width: '100%' }}>
      <div>
        <div className={classes.sectionTitle} onClick={() => setIsExpanded(!isExpanded)}>
          <Typography component="h1" style={{ color: '#FFFFFF', fontSize: 18, fontWeight: 700, fontFamily: 'Poppins' }}>
            Restitutions
          </Typography>
          <IconButton style={{ color: '#FFFFFF', padding: '4px' }}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      </div>
      <Collapse in={isExpanded}>
        <h3 className={classes.label}>Liste des restitutions</h3>
        {variables?.length ? (
          variables?.map((variable: any, index: number) => (
            <div className={classes.accordionContainer} key={variable.id}>
              <OaAccordion
                summaryText={variable.name}
                detailsText=""
                handleDelete={handleDelete}
                handleEdit={handleEdit}
                index={index}
                accordionStyleOverride={classes.fullWidth}
                accordionDetailsComponent={OaAccordionDetails(variable)}
                codeColor={variable.codeColor}
                minInterval={variable.minInterval}
                maxInterval={variable.maxInterval}
                diagram={4}
              />
            </div>
          ))
        ) : (
          <NoVariable hasError={errors?.variables} />
        )}

        {!isVariableButtonDisabled && (
          <div className={classes.flexContainer}>
            <Button
              onClick={handleClick}
              className={classes.btnPrimary}
            >
              <span className={classes.textHeader}>Ajouter une restitution</span>
            </Button>
          </div>
        )}
        <OaPopin
          open={variableDeletionConfirmPopin.open}
          title={variableDeletionConfirmPopin.title}
          handleConfirm={handlePopinConfirm}
          handleClose={handlePopinClose}
        >
          <div className={classes.modalContent}>
            <Typography variant="h6" className={classes.modalText}>
              {variableDeletionConfirmPopin.content}
            </Typography>
          </div>
        </OaPopin>
      </Collapse>
    </div>
  );
};

export default VariablesSection;
